import { ConnectedUserAnimal } from '@/dataV3/Animal/ConnectedUserAnimal'
import { ReviewsSummary } from '@/dataV3/Review/ReviewsSummary'
import { Picture } from '@/dataV3/Common/Picture'
import { MemberPermissions } from '@/dataV3/User/MemberPermissions'
import { MemberOptions } from '@/dataV3/User/MemberOptions'
import { UserSettings } from '@/dataV3/User/UserSettings'
import { IRI, LDObject } from 'emt-library'

export enum RegistrationType {
  petsitter = 'petsitter',
  petowner = 'owner',
  borrower = 'borrower',
  petsitterInRegistration = 'petsitterInRegistration',
}

export interface ConnectedUser extends LDObject<'ConnectedUser'> {
  '@email': IRI
  '@disable': IRI
  '@delete': IRI
  '@refreshTopic'?: IRI
  id: string
  displayName: string
  registrationType: RegistrationType
  isPremium: boolean
  description: string
  mainPictureThumbnailUrl: string
  locale: string
  brand: string
  countryCode: string
  permissions: MemberPermissions
  memberOptions: MemberOptions
  latitude: number
  longitude: number
  settings: UserSettings
  animals: ConnectedUserAnimal[]
  pictures: Picture[]
  reviewsSummary: ReviewsSummary
  tendersEnabled?: boolean | undefined
  hasRequestedPetsitting?: boolean | undefined
}
